<template>
  <div class="column is-12">
    <p>
      You have driven <b>{{ carOverviewData.tracked_distance | distance}}</b>.
    </p>
    <p>
      Your cars absolute average fuel consumption
      is <b>{{ carOverviewData.absolute_fuel_consumption | consumption }}</b>.
    </p>
    <p>
      You have burned around <b>{{ carOverviewData.total_estimated_fuel_amount | volume }}</b>
      of fuel in total cost around <b>{{ carOverviewData.total_estimated_fuel_price | price }}</b>
    </p>
    <p>
      You have spent <b>{{ carOverviewData.total_expenses | price }}</b>
      on maintenance and other things,
      which results in <b>{{ carOverviewData.absolute_price_per_km | pricePerKm }}</b>.
    </p>
  </div>
</template>

<script>
import CAR_OVERVIEW_DATA from '@/graphql/statistics/carOverviewData.gql';

export default {
  name: 'StatisticsText',
  data() {
    return {
      carOverviewData: {
        tracked_distance: 0,
        absolute_fuel_consumption: 0,
        total_estimated_fuel_amount: 0,
        total_estimated_fuel_price: 0,
        total_expenses: 0,
        absolute_price_per_km: 0,
      },
    };
  },
  apollo: {
    carOverviewData: {
      query: CAR_OVERVIEW_DATA,
      variables() {
        return {
          carId: this.$route.params.id,
        };
      },
    },
  },
};
</script>

<style scoped>

</style>
